var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"text":""},on:{"click":function($event){$event.preventDefault();return _vm.signOut.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t("appbar.logout"))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }